import type { ReactNode } from "react";
import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider } from "@mui/material/styles";
import { SnackbarProvider } from "notistack";

import theme from "../theme";

/**
 * `defaultMode="system"` makes MUI seed the color scheme from
 * prefers-color-scheme and then persist any explicit user choice to
 * localStorage, which is what the header's mode toggle writes to.
 */
export default function AppProviders({ children }: { children: ReactNode }) {
  return (
    <ThemeProvider theme={theme} defaultMode="system">
      <CssBaseline enableColorScheme />
      <SnackbarProvider
        maxSnack={3}
        autoHideDuration={4000}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      >
        {children}
      </SnackbarProvider>
    </ThemeProvider>
  );
}
